import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './index';

export const reducers = {
  sendSapConfiguration(state, action: PayloadAction<string>) {
    state.isLoading = true;
  },
  sendSapConfigurationSuccess(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  sendSapConfigurationFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
  resetSapConfiguration(state) {
    state.isLoading = initialState.isLoading;
    state.data = initialState.data;
    state.error = initialState.error;
  },
};
